import { render, staticRenderFns } from "./AvailableDocuments.vue?vue&type=template&id=34ecf416"
import script from "./AvailableDocuments.vue?vue&type=script&lang=js"
export * from "./AvailableDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports